/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 *
 * @export
 * @interface SetPublishedVersionRequest
 */
export interface SetPublishedVersionRequest {
  /**
   * Software type identifier: 0=CM7, 1=CM4, 2=ESP
   *
   * @type {number}
   * @memberof SetPublishedVersionRequest
   * @example 0
   */
  software_type: SetPublishedVersionRequestSoftwareTypeEnum;

  /**
   * Version to set as published (semver format)
   *
   * @type {string}
   * @memberof SetPublishedVersionRequest
   * @example 1.2.3
   */
  version: string;
}

/**
 * @export
 * @enum {string}
 */
export enum SetPublishedVersionRequestSoftwareTypeEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
}
